import * as React from 'react'

import {
  Box,
  Card,
  RadioButton,
  WizardStepRenderParams,
} from '@factorialco/deprecated-design-system'

import TextArea from '../../../core/components/TextArea'
import i18n from '../../../core/lib/i18n'
import { PulseConfiguration } from '../../lib/pulse'

export const MessageStep = ({
  data,
  onDataChanged,
}: WizardStepRenderParams<PulseConfiguration>) => {
  return (
    <Box gap="s16">
      <Box gap="s16">
        <Card onClick={() => onDataChanged({ ...data, questionType: 'daily_question' })}>
          <Card.Title
            action={
              <RadioButton
                value="daily"
                checked={data.questionType === 'daily_question'}
                onChange={() => onDataChanged({ ...data, questionType: 'daily_question' })}
              />
            }
          >
            {i18n.t('engagement.pulse.activation.message.daily_question.title')}
          </Card.Title>
        </Card>

        <Card onClick={() => onDataChanged({ ...data, questionType: 'weekly_question' })}>
          <Card.Title
            action={
              <RadioButton
                value="daily"
                checked={data.questionType === 'weekly_question'}
                onChange={() => onDataChanged({ ...data, questionType: 'weekly_question' })}
              />
            }
          >
            {i18n.t('engagement.pulse.activation.message.weekly_question.title')}
          </Card.Title>
        </Card>

        <Card onClick={() => onDataChanged({ ...data, questionType: 'custom' })}>
          <Card.Title
            action={
              <RadioButton
                value="daily"
                checked={data.questionType === 'custom'}
                onChange={() => onDataChanged({ ...data, questionType: 'custom' })}
              />
            }
          >
            {i18n.t('engagement.pulse.activation.message.custom.title')}
          </Card.Title>
          <Card.Description>
            {i18n.t('engagement.pulse.activation.message.custom.description')}
          </Card.Description>
          <Card.ExpandableContent expanded={data.questionType === 'custom'}>
            <TextArea
              mandatory={data.questionType === 'custom'}
              placeholder={i18n.t('engagement.pulse.activation.message.custom.placeholder')}
              value={data.question}
              onChange={(value: string) => {
                onDataChanged({ ...data, question: value })
              }}
              maxLength={255}
            />
          </Card.ExpandableContent>
        </Card>
      </Box>
    </Box>
  )
}
